<template>

  <alert type="info" icon="warning" align="top">
    <div slot="content">
      {{$t('message.labelStartProgramOver')}}
      <br/>
      <a
        @click="confirmRestart"
        slot="action"
        class="pointer"
        v-text="$t('message.labelClickHere')"
      ></a>
    </div>
  </alert>
</template>
<script>

  import AccountApi from '../../api/Account'
  import Alert from "../Alert/Alert";

  export default {
    components: {Alert},
    name: 'reset-account',
    methods: {
      confirmRestart() {
        let self = this;
        self.$alert({
          title: self.$t('message.confirmRemoveTitle'),
          text: self.$t('message.confirmResetAccount'),
          type: "warning",
          showCancelButton: true,
          showLoaderOnConfirm: false,
          confirmButtonColor: "white",
          cancelButtonColor: "white",
          preConfirm: function () {
            return AccountApi.resetWeek1()
          }
        })
          .then(function () {
            self.$alert({
              title: self.$t('message.labelSuccess'),
              text: self.$t('message.confirmedResetAccount'),
              type: "success",
              showCancelButton: false,
              showLoaderOnConfirm: false,
              confirmButtonColor: "white",
              cancelButtonColor: "white"
            });
            setTimeout(function () {
              window.location.reload();
            }.bind(self), 1000)
          });
      },
    }
  }

</script>



// WEBPACK FOOTER //
// ResetAccount.vue?fa2f62fe